import React, { useState, useEffect } from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import { getAdminUser } from '../../utils/authSessionStorage';

const Layout = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [isSidebarOpen, setIsSidebarOpen] = useState(!isMobile);
  const location = useLocation();
  const navigate = useNavigate();
  const adminUser = getAdminUser();
  const isAdminUser = /admin\s*user/i.test(adminUser?.role || '') || String(adminUser?.role || '').toLowerCase().replace(/\s+/g, '') === 'adminuser';

  useEffect(() => {
    if (isAdminUser) {
      const allowedPaths = ['/dashboard', '/events', '/contacts', '/promotions'];
      if (!allowedPaths.includes(location.pathname)) {
        navigate('/dashboard', { replace: true });
      }
    }
  }, [isAdminUser, location.pathname, navigate]);

  useEffect(() => {
    setIsSidebarOpen(!isMobile);
  }, [isMobile]);

  const handleToggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const handleCloseSidebar = () => {
    if (isMobile) {
      setIsSidebarOpen(false);
    }
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <Header onToggleSidebar={handleToggleSidebar} />
      <Sidebar open={isSidebarOpen} mobile={isMobile} onClose={handleCloseSidebar} />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: { xs: 1.5, sm: 2, md: 3 },
          mt: { xs: 7.5, md: 8 },
          minHeight: '100vh',
          bgcolor: 'background.default',
          width: isMobile ? '100%' : `calc(100% - ${isSidebarOpen ? '240px' : '0px'})`,
          transition: (theme) => theme.transitions.create(['width'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default Layout;
